import React from "react";
import ReactDOM from "react-dom";
import App from "App";
import { store } from "utils/store";
import { Provider } from "react-redux";
import * as serviceWorker from "serviceWorker";
import smoothscroll from "smoothscroll-polyfill";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import strings from "global/constants/StringConstants";
import { PostHogProvider } from "@posthog/react";
import { scrubSensitiveData } from "utils/posthogScrub";
import { DndProvider } from "react-dnd-multi-backend";
import { HTML5toTouch } from "rdndmb-html5-to-touch";
import urls from "global/constants/UrlConstants";
import { IS_EMBED } from "embed/embedMode";

// steps to override default smooth scrolling behaviour in browsers
declare global {
  interface Window {
    __forceSmoothScrollPolyfill__: boolean;
  }
}
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

const options = {
  api_host: "https://us.i.posthog.com",
  defaults: "2026-01-30",
  before_send: scrubSensitiveData,
} as const;

// Embedded Components (a widget inside a partner's iframe): no PostHog and no reCAPTCHA -- nothing in a
// widget is a login or sign-up form, and the partner's page should load no third-party trackers from us.
const app =
  urls.PROD && !IS_EMBED ? (
    <PostHogProvider
      apiKey={"phc_KJJUphiIcyNrSWoelZ48cgIaLgOFJjnhsB8lq9NGTsK"}
      options={options}
    >
      <App />
    </PostHogProvider>
  ) : (
    <App />
  );

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <DndProvider options={HTML5toTouch}>
        {IS_EMBED ? (
          app
        ) : (
          <GoogleReCaptchaProvider reCaptchaKey={strings.RECAPTCHA_SITE_KEY}>
            {app}
          </GoogleReCaptchaProvider>
        )}
      </DndProvider>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root"),
);

serviceWorker.unregister();
